module.exports = __webpack_public_path__ + "static/img/bonus_1.03ed8a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jzsg/bonus_1.png
// module id = mHEo
// module chunks = 0